// KAN-1342: публичный API сущности «беседа» единого чата.
export * from "./model/types";
export { conversationKeys } from "./api/conversation-keys";
export { patchMessages } from "./api/patch-messages";
export {
  useScrimOptions,
  useMyLfgCards,
  useChatLists,
  useConversationMediaCounts,
  useConversationMedia,
  conversationMediaQuery,
  useConversationMembers,
  useConversationPins,
  useConversationMessages,
  useConversationSearch,
  useConversations,
  useReactionEmojis,
} from "./api/use-conversations";
export { useSelectedConversation } from "./api/use-selected-conversation";
export { parseScrimCard, toScrimOptions, parseLfgCard, toLfgCards, toChatList, toChatLists, toChatMessage, toChatPins, toConversation, toMediaCounts, toMediaItems, toReactions } from "./lib/to-conversation";
export { canAddReaction, keepMyReactionTimes, lastOwnReaction, reactionLimit, reactionPlan, toggleReactionLocal, visibleReactions, type ReactionView } from "./lib/reactions";
export {
  applyEdit,
  applyReactions,
  applyMessageToList,
  flattenPages,
  markDeletedForAll,
  markReadUpTo,
  removeAttachment,
  removeMessage,
  upsertMessage,
  type MessagesData,
} from "./lib/messages-cache";
export { useChatSelectionStore, type TypingInfo } from "./model/chat-selection-store";
export { ChatAvatar } from "./ui/chat-avatar";
